import { PlData } from '../../plCapsuleData';
import React from 'react';
import { Tooltip } from '@instinet-analytics/core-lib';
import { usePlPointedTimeData } from 'widgets/plCapsule/hooks';
import classNames from 'classnames';

interface PlCapsuleChartHeaderValuesProps {
    data: PlData;
    hideRealized?: boolean;
    showUnrealized?: boolean;
    showTotal?: boolean;
}

export function PlCapsuleChartHeaderValues(
    props: PlCapsuleChartHeaderValuesProps
) {
    const { data, hideRealized, showUnrealized, showTotal } = props;

    const { total, realised, realisedClass, unrealised } =
        usePlPointedTimeData(data);

    const realisedAsMainHeader = !showTotal && !showUnrealized;
    const unrealisedAsMainHeader = !showTotal && hideRealized;

    const realisedLabelCssClasses = classNames(
        'realised',
        realisedClass,
        realisedAsMainHeader && 'main-header'
    );

    const realisedLabel = (
        <div className={realisedLabelCssClasses}>
            <Tooltip
                text={
                    'Profit/loss of the executed portion of the order compared to the chosen benchmark.'
                }
            >
                {realised}
            </Tooltip>
        </div>
    );

    const unrealisedLabelCssClasses = classNames(
        'unrealised',
        unrealisedAsMainHeader && 'main-header'
    );
    const showingItems =
        (hideRealized ? 0 : 1) +
            (showTotal ? 1 : 0) +
            (showUnrealized ? 1 : 0) >
        1;

    const unrealisedLabel = (
        <div className={unrealisedLabelCssClasses}>
            <Tooltip
                text={
                    'Profit/loss of the remaining unexecuted portion of the order compared to the chosen benchmark.'
                }
            >
                {unrealised}
            </Tooltip>
        </div>
    );
    return (
        <div className="PlCapsuleChartHeaderValues">
            {showTotal && (
                <div className="total main-header">
                    <Tooltip
                        text={
                            'Sum of Realized (executed portion of order) P&L and Unrealized (unexecuted portion) P&L. Unrealized P&L uses the last traded price as an indicative price for any unfilled shares.'
                        }
                    >
                        {total}
                    </Tooltip>
                </div>
            )}
            {realisedAsMainHeader && realisedLabel}
            {unrealisedAsMainHeader && unrealisedLabel}
            {showingItems && (
                <div className="items">
                    {realisedLabel}
                    {unrealisedLabel}
                </div>
            )}
        </div>
    );
}
